import React, { useState } from "react";

import i18n from "i18next";

import { Modal, View, Text, Pressable, StyleSheet } from "react-native";

import RootStore from "../Store";

const { userInfo } = RootStore.getInstance();

interface Props {
  reason: string;
  resetErr: () => void;
}

export const ModalQLerr = ({ reason, resetErr }: Props): JSX.Element => {

  const [isOpen, setIsOpen] = useState<boolean>(true);

  let title = "";
  let body = "";
  let callback: () => any = () => {};

  switch (reason) {
    case "Token missing, access denied":
      title = i18n.t("EXPIRED_TOKEN");
      body = i18n.t("EXPIRED_TOKEN_TEXT");
      callback = () => {
        resetErr();
        userInfo.logout();
      };
      break;
    default:
      title = i18n.t("UNKOWN_ERROR_TITLE");
      body = i18n.t("UNKOWN_ERROR_DESCRIPTION");
      callback = () => {
        resetErr();
        setIsOpen(false);
      };
      break;
  }

  return (
    <View style={modalStyle.centeredView}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={isOpen}
        onRequestClose={() => null}
      >
        <View style={modalStyle.centeredView}>
          <View style={modalStyle.modalView}>
            <Text style={modalStyle.modalTitle}>{title}</Text>
            <Text style={modalStyle.modalText}>{body}</Text>
            <View style={modalStyle.buttonView}>
              <Pressable
                style={[
                  modalStyle.button,
                  modalStyle.pressable,
                  modalStyle.buttonClose,
                ]}
                onPress={() => {
                  callback();
                }}
              >
                <Text style={[modalStyle.textStyle]}>OK</Text>
              </Pressable>
            </View>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const modalStyle = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modalView: {
    position: "relative",
    margin: 20,
    backgroundColor: "white",
    borderRadius: 20,
    paddingHorizontal: 35,
    paddingBottom: 20,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  pressable: {
    flex: 1,
  },
  buttonClose: {
    backgroundColor: "#D71D9A",
  },
  textStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  modalText: {
    marginBottom: 15,
    textAlign: "center",
    color: "grey",
  },
  modalTitle: {
    fontSize: 24,
    marginBottom: 15,
    marginTop: 20,
    color: "black",
    textAlign: "center",
  },
  buttonView: {
    justifyContent: "center",
    flexDirection: "row",
    gap: 3,
    alignItems: "center",
  },
  buttonCloseView: {
    alignSelf: "flex-end",
    marginVertical: 5,
  },
  buttonCloseModal: {
    borderRadius: 50,
    marginTop: 10,
    elevation: 2,
  },
});

export default ModalQLerr;
